export default function auth(state = {}, action) {
  switch (action.type) {
    case 'LOGIN':
      return action.authData

    default:
      return state
  }
}
